// libs
import React from 'react';

import { cn } from '@lyearn/style';
// config
import contentConfig from '@/modules/content/config';
// utils
import renderImage from '@/modules/content/utils/renderImage';
import {
  ContentEntity,
  EventStatusEnum,
  KnowledgeAssetSubTypeEnum,
  Maybe,
  ResourceTypeEnum,
} from '@/types/schema';
import { CARD_IMAGES } from '@/utils/cardImage';
import { grayScale } from '@/utils/styles';

// context
import { useLearningContent } from '../context';
// types
import { IconProps } from '../types';

export const getKnowledgeAssetStaticCover = (
  knowledgeAssetSubType?: Maybe<KnowledgeAssetSubTypeEnum>,
) => {
  if (!knowledgeAssetSubType) {
    return '';
  }
  const subTypes = [
    KnowledgeAssetSubTypeEnum.Persona,
    KnowledgeAssetSubTypeEnum.PersonaJourney,
    KnowledgeAssetSubTypeEnum.Solution,
    KnowledgeAssetSubTypeEnum.CustomerStory,
    KnowledgeAssetSubTypeEnum.SalesConversation,
    KnowledgeAssetSubTypeEnum.SolutionWin,
  ];
  const index = subTypes.indexOf(knowledgeAssetSubType);
  if (index < 0) {
    return '';
  }
  return CARD_IMAGES[ResourceTypeEnum.Scorm][index];
};

function Icon({ className = 'w-40 h-40', width = 40, height = 40 }: IconProps) {
  const { content } = useLearningContent();

  const isKnowledgeAssetType = content.type === ResourceTypeEnum.KnowledgeAsset;

  const knowledgeAssetStaticCover = isKnowledgeAssetType
    ? getKnowledgeAssetStaticCover(content?.knowledgeAssetSubType)
    : '';

  const { image } = contentConfig[content.type!].icons?.getContentImage(content as ContentEntity)!;
  const isGrayScale = content.event?.status === EventStatusEnum.Completed;

  return renderImage({
    width,
    height,
    image: image || knowledgeAssetStaticCover,
    className: cn(className, isGrayScale ? grayScale : undefined),
    contentName: content.name!,
  });
}

export default React.memo(Icon);
